export function Spinner({ label }: { label?: string }) {
  return (
    <div className="row" style={{ gap: 10, color: "var(--muted)" }}>
      <span className="spinner" aria-hidden="true" />
      {label && <span>{label}</span>}
    </div>
  );
}
